<div class="sidebar custom-scrollbar">
  <div class="sidebar-user text-center">
    <div><img class="img-60 rounded-circle" src="assets\images\dashboard\defalt_image.jpg" alt="#">
      <div class="profile-edit"><a>
          <i class="icofont icofont-pencil-alt-5"><input class="upload" type="file" (change)="readUrl($event)" /></i>
        </a></div>
    </div>
    <h6 class="mt-3 f-14" style="text-transform: initial !important;">{{personUserName}}</h6>
    <p>{{personFullName}}</p>
  </div>

  <ul class="sidebar-menu">
    @for(menuItem of menuItems;track menuItem){
      <li [ngClass]="{active: menuItem.active}">
        <a *ngIf="menuItem.type === 'mainmenu'" [routerLink]="[menuItem.path]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidebar-header">
          <app-feather-icons [icon]="menuItem.icon"></app-feather-icons>
          <span>{{ menuItem.title | translate }}
            <span *ngIf="menuItem.badgeType" class="badge badge-{{menuItem.badgeType}} me-3">{{menuItem.badgeValue}}</span>
          </span>
        </a>
        
        <a *ngIf="menuItem.type === 'qrcodescan'" [routerLink]="[menuItem.path]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidebar-header">
          <i class="fa-qrcode"></i>&nbsp;
          <span>{{ menuItem.title | translate }}
          </span>
        </a>
        <a *ngIf="menuItem.type === 'reports'" [routerLink]="[menuItem.path]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidebar-header">
          <i class="fa fa-chart-bar"></i>&nbsp;
          <span>{{ menuItem.title | translate }}
          </span>
          
        </a>
          <a *ngIf="menuItem.type === 'loginaudit' && isSuperAdmin === true" [routerLink]="[menuItem.path]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidebar-header">
            <i class="fa fa-history"></i>&nbsp;
            <span>{{ menuItem.title | translate }}
            </span>
            
          </a>

        <a *ngIf="menuItem.type === 'movements'" [routerLink]="[menuItem.path]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidebar-header">
          <app-feather-icons [icon]="menuItem.icon"></app-feather-icons>
          <span>{{ menuItem.title | translate }}
          </span>
          
        </a>
        <!-- Sub -->
        @if(menuItem.type === 'sub'){
        <a href="javascript:void(0)"  class="sidebar-header" (click)="toggleNavActive(menuItem)">
          <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title | translate}}
            @if(menuItem.badgeType){
            <span class="badge badge-{{menuItem.badgeType}} me-3">{{menuItem.badgeValue}}</span>
            }
          </span>
          @if(menuItem.children){
          <i class="fa fa-angle-right pull-right"></i>
          }
        </a>
        }
        <!-- Link -->
        @if(menuItem.type === 'link'){
        <a [routerLink]="!menuItem.type ? null : [menuItem.path]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidebar-header">
          <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title | translate}}
            @if(menuItem.badgeType){
            <span class="badge badge-{{menuItem.badgeType}} me-3">{{menuItem.badgeValue}}</span>
            }
          </span>
          <!-- @if(menuItem.children){
          <i class="fa fa-angle-right pull-right"></i>
          } -->
        </a>
        }
        <!-- External Link -->
        @if(menuItem.type === 'extLink'){
        <a href="{{ !menuItem.type ? null : menuItem.path }}" class="sidebar-header">
          <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title | translate}}
            @if(menuItem.badgeType){
            <span class="badge badge-{{menuItem.badgeType}} me-3">{{menuItem.badgeValue}}</span>
            }
          </span>
          @if(menuItem.children){
          <i class="fa fa-angle-right pull-right"></i>
          }
        </a>
        }
        <!-- External Tab Link -->
        @if(menuItem.type === 'extTabLink'){
        <a href="{{ !menuItem.type ? null : menuItem.path }}" target="_blank" class="sidebar-header">
          <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title | translate}}
            @if(menuItem.badgeType){
            <span class="badge badge-{{menuItem.badgeType}} me-3">{{menuItem.badgeValue}}</span>
            }
          </span>
          @if(menuItem.children){
          <i class="fa fa-angle-right pull-right"></i>
          }
        </a>
        }
        <!-- 2nd Level Menu -->
        @if(menuItem.children){
        <ul class="sidebar-submenu" [ngClass]="{'menu-open': menuItem.active, 'menu-close': !menuItem.active }">
          @for(childrenItem of menuItem.children;track childrenItem){
          <li [ngClass]="{active: childrenItem.active}">
            <!-- Sub -->
            <ng-container *hasClaim="childrenItem.claimType">
            @if(childrenItem.type === 'sub'){
            <a href="javascript:void(0)" (click)="toggleNavActive(childrenItem)">
              <i class="fa fa-circle"></i>
              <span> {{childrenItem.title | translate}}
                @if(childrenItem.badgeType){
                <span class="badge badge-{{childrenItem.badgeType}} pull-right">{{childrenItem.badgeValue}}</span>
                }
              </span>
              @if(childrenItem.children){
              <i class="fa fa-angle-down pull-right"></i>
              }
            </a>
            }
            <!-- Link -->
            @if(childrenItem.type === 'link'){
            <a  [routerLink]="!childrenItem.type ? null : [childrenItem.path]" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <i class="fa fa-circle"></i><span>{{childrenItem.title | translate}}
                @if(childrenItem.badgeType){
                <span class="badge badge-{{childrenItem.badgeType}} pull-right">{{childrenItem.badgeValue}}</span>
                }
              </span>
              <!-- @if(childrenItem.children){
              <i class="fa fa-angle-down pull-right"></i>
              } -->
            </a>
            }
          </ng-container>
            <!-- External Link -->
            @if(childrenItem.type === 'extLink'){
            <a href="{{ !childrenItem.type ? null : childrenItem.path }}" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <i class="fa fa-circle"></i><span>{{childrenItem.title | translate}}
                @if(childrenItem.badgeType){
                <span class="badge badge-{{childrenItem.badgeType}} pull-right">{{childrenItem.badgeValue}}</span>
                }
              </span>
              @if(childrenItem.children){
              <i class="fa fa-angle-down pull-right"></i>
              }
            </a>
            }
            <!-- External Tab Link -->
            @if(childrenItem.type === 'extTabLink'){
            <a href="{{ !childrenItem.type ? null : childrenItem.path }}" target="_blank">
              <i class="fa fa-circle"></i><span>{{childrenItem.title | translate}}
                @if(childrenItem.badgeType){
                <span class="badge badge-{{childrenItem.badgeType}} pull-right">{{childrenItem.badgeValue}}</span>
                }
              </span>
              @if(childrenItem.children){
              <i class="fa fa-angle-down pull-right"></i>
              }
            </a>
            }
            <!-- 3rd Level Menu -->
            @if(childrenItem.children){
            <ul class="sidebar-submenu">
              @for(childrenSubItem of childrenItem.children;track childrenSubItem){
              <li>
                <!-- Link -->
                @if(childrenSubItem.type === 'link'){
                <a [routerLink]="!childrenSubItem.type ? null : [childrenSubItem.path]" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <i class="fa fa-circle"></i><span> {{childrenSubItem.title | translate}}
                    @if(childrenSubItem.badgeType){
                    <span
                      class="badge badge-{{childrenSubItem.badgeType}} pull-right">{{childrenSubItem.badgeValue}}</span>
                    }
                  </span>
                </a>
                }
                <!-- External Link -->
                @if(childrenSubItem.type === 'extLink'){
                <a href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <i class="fa fa-circle"></i><span>{{childrenSubItem.title | translate}}
                    @if(childrenSubItem.badgeType){
                    <span
                      class="badge badge-{{childrenSubItem.badgeType}} pull-right">{{childrenSubItem.badgeValue}}</span>
                    }
                  </span>
                </a>
                }
                <!-- External Tab Link -->
                @if(childrenSubItem.type === 'extTabLink'){
                <a href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}" target="_blank">
                  <i class="fa fa-circle"></i><span>{{childrenSubItem.title | translate}}
                    @if(childrenSubItem.badgeType){
                    <span
                      class="badge badge-{{childrenSubItem.badgeType}} pull-right">{{childrenSubItem.badgeValue}}</span>
                    }
                  </span>
                </a>
                }
              </li>
              }
            </ul>
            }
          </li>
          }
        </ul>
        }
      </li>
      }
  </ul>
</div>